import styled from "styled-components";

export const IconContainer = styled.div`
  display: grid;
  place-content: center;
  width: ${({ size }) => size};
  height: ${({ size }) => size};

  svg {
    width: ${({ size }) => size};
    height: ${({ size }) => size};
  }
`;
